import template from './qualificationsModal.html';
import controller from './qualificationsModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    qualification: '<',
    presetList: '<',
  },
};
